import router from "./index";
import store from "../store/index"

router.beforeEach((to,from,next)=>{
    //没有登录的时候直接放行去index页面检查
    if(!window.sessionStorage.getItem("Authorization")){
        window.location.href = "/login.html";
    }else if(store.state.hideMenu.includes(to.name)){
        //登录之后，跳转前拦截，无法访问隐藏的页面，并提示
        alert("暂无权限")
        window.location.href = "/login.html";
        //清空需要隐藏的页面name清空按钮权限  移除用户权限数据
        store.commit("setHideMenu",[]);
        store.commit("setButtonMenu",[]);
        sessionStorage.removeItem('ShowList')
        sessionStorage.removeItem('ButtonList')
        //移除身份认证数据
        sessionStorage.removeItem('Authorization')
    }else{
        //有权限的页面直接放行
        next()
    }
})